import { type RouteRecordRaw } from "vue-router";
import HomeView from "@/views/HomeView.vue";
import ElectricalInstallationsView from "@/views/ElectricalInstallationsView.vue";
import HeatPumpsView from "@/views/HeatPumpsView.vue";
import SolarPanelsView from "@/views/SolarPanelsView.vue";
import VideoSurveillanceView from "@/views/VideoSurveillanceView.vue";
import AirConditioning from "@/views/AirConditioning.vue";
import ContactView from "@/views/ContactView.vue";
import NotFoundView from "@/views/NotFoundView.vue";

export const routes = [
  {
    path: "/",
    name: "HomePage",
    component: HomeView,
  },
  {
    path: "/services/electrical-installations",
    name: "ElectricalInstallationsPage",
    component: ElectricalInstallationsView,
  },
  {
    path: "/services/heat-pumps",
    name: "HeatPumpsPage",
    component: HeatPumpsView,
  },
  {
    path: "/services/solar-panels",
    name: "SolarPanelsPage",
    component: SolarPanelsView,
  },
  {
    path: "/services/video-surveillance",
    name: "VideoSurveillancePage",
    component: VideoSurveillanceView,
  },
  {
    path: "/services/air-conditioning",
    name: "AirConditioning",
    component: AirConditioning,
  },
  {
    path: "/contact",
    name: "ContactPage",
    component: ContactView,
  },
  {
    path: "/:pathMatch(.*)*",
    name: "NotFound",
    component: NotFoundView,
  },
] as const satisfies readonly RouteRecordRaw[];

export type RouteName = (typeof routes)[number]["name"];
